import { render, staticRenderFns } from "./boxWiki.vue?vue&type=template&id=895a77fe&"
import script from "./boxWiki.vue?vue&type=script&lang=ts&"
export * from "./boxWiki.vue?vue&type=script&lang=ts&"
import style0 from "./boxWiki.vue?vue&type=style&index=0&id=895a77fe&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports